
import i18n from '@/i18n';
export default [
    {
        get text() { return i18n?.global?.t('tableHeaders.id')}, 
        value: 'id',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.name')},
        value: 'name',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.category')},
        value: 'category',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.manufacturerSymbol')},
        value: 'symbol',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('common.entriesLocation')},
        value: 'entries_location',
    },
    {
        get text() { return i18n?.global?.t('common.lastLocation')},
        value: 'last_entry_with_location',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.registryNumber')},
        value: 'registry_no',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.min')},
        value: 'min_quantity',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.opt')},
        value: 'opt_quantity',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.quantity')},
        value: 'quantity',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('common.classification')},
        value: 'classification',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.price')},
        value: 'max_price',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('common.unit')},
        value: 'preferred_unit',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.manufacturer')},
        value: 'manufacturer_id',
        sortable: true,
    },
    { value: 'operation', width: 54, fixed: true },
];
